import { Formik } from "formik";
import { FC, createContext } from "react";
import ParaclinicalDetail from "./components/ParaclinicalDetail";

export interface ParaclinicalPageContextProps {}

interface IProps {}

const initialContext = {};

export const ParaclinicalContext =
  createContext<ParaclinicalPageContextProps>(initialContext);

export const ParaclinicalPage: FC<IProps> = (props) => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {}}>
      <ParaclinicalContext.Provider value={{}}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1 ">
              <ParaclinicalDetail />
            </div>
          </div>
        </div>
      </ParaclinicalContext.Provider>
    </Formik>
  );
};

export default ParaclinicalPage;
